import React, { Component } from 'react'
import axios from './axios'
import Translate from '../components/translate/conf'
import ReactDOMServer from 'react-dom/server';
import 'datatables.net-buttons-bs4/js/buttons.bootstrap4.min.js'
import 'datatables.net-responsive-bs4/js/responsive.bootstrap4.min.js'
import { Link } from 'react-router-dom';
import ModalLoading from '@app/components/modal-loading/modal-loading';

const $ = require('jquery');
$.DataTable = require('datatables.net');

export default class OltStatusTable extends Component {

  constructor(props) {
    super(props)
    this.state = {
      rows: [],
      mLoading: true
    }
  }

  getFullOltData = async () => {
    let oltTable = await axios.get('/api/olttable')
    let slotTable = await axios.get('/api/slottable')
    if( oltTable.data.data !== undefined && slotTable.data.data !== undefined ){
      oltTable = oltTable.data.data;
      slotTable.data.data.forEach((v,i,arr)=> {
        for(let j=0;j<oltTable.length;j++){
          if( v.id == oltTable[j].id ){
            arr[i] = { ...v, ...oltTable[j] }
            break;
          }
        }
      })
      return slotTable;
    }
    return { data: [] };
  }

  getTableData = async () => {
    try {
      const res = await this.getFullOltData();
      this.setState(
        {
          rows: res.data["data"],
          mLoading: false
        },
        () => {
          $(this.tbl).DataTable({
            "search": {
              "search": this.props.match.params.filter
            },
            "pageLength": 8,
            "lengthMenu": [0, 2, 4, 8],
            "responsive": true,
            "columnDefs": [
              {
                visible: false,
                targets: 0,
              },
              {
                width: '35%',
                targets: 1,
                className: 'th-bg-blue td-blue'
              },
              {
                targets: 2,
                className: 'dt-center th-bg-blue td-blue',
                visible: (localStorage.getItem('showOLTAddress') === "true")
              },
              {
                targets: [3, 4, 8],
                className: 'dt-center th-bg-blue td-blue'
              },
              {
                targets: 9,
                className: 'dt-center th-bg-blue td-blue',
                orderable: false
              },
              {
                targets: 5,
                className: 'dt-center th-bg-blue td-blue',
                render: (value) => {
                  if (parseInt(value) == 1) {
                    value = ReactDOMServer.renderToString(<div className='text-online'><Translate transVar='OLT.Status.Online' /></div>)
                  } else {
                    value = ReactDOMServer.renderToString(<div className='text-offline'><Translate transVar='OLT.Status.Offline' /></div>)
                  }
                  return value;
                }
              },
              {
                targets: 6,
                className: 'dt-center th-bg-blue td-blue',
                render: (value) => {
                  if (parseInt(value) == 1) {
                    value = ReactDOMServer.renderToString(<Translate transVar='OLT.Status.Enabled' />)
                  } else {
                    value = ReactDOMServer.renderToString(<Translate transVar='OLT.Status.Disabled' />)
                  }
                  return value;
                }
              },
              {
                targets: 7,
                className: 'dt-center th-bg-blue td-blue',
                render: (value) => {
                  if (parseInt(value) == 2) {
                    value = ReactDOMServer.renderToString(<Translate transVar='OLT.Status.Enabled' />)
                  } else {
                    value = ReactDOMServer.renderToString(<Translate transVar='OLT.Status.Disabled' />)
                  }
                  return value;
                }
              },
            ],
            initComplete: function () {
              this.api()
                  .columns()
                  .every(function () {
                      var that = this;
                      $('input', this.footer()).on('keyup change clear', function () {
                          if (that.search() !== this.value) {
                              that.search(this.value).draw();
                          }
                      });
                  });
            },
          });
        }
      )
    } catch (e) { 
      console.log(e)
    }
  }

  componentDidMount() {
    this.getTableData();
  }

  tHeader = () => {
    return (
      <>
        <thead>
          <tr>
            <th></th>
            <th><Translate transVar='OLT.Name' /></th>
            <th><Translate transVar='OLT.IPAddress' /></th>
            <th><Translate transVar='OLT.MACAddress' /></th>
            <th><Translate transVar='OLT.Slot' /></th>
            <th><Translate transVar='OLT.Status.LinkStatus' /></th>
            <th><Translate transVar='OLT.Status.CTC' /></th>
            <th><Translate transVar='OLT.Status.NVS' /></th>
            <th><Translate transVar='OLT.Status.Version' /></th>
            <th></th>
          </tr>
        </thead>
      </>
    );
  }

  tFooter = () => {
    return (
      <>
        <tfoot>
          <tr>
            <td></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='OLT.Name' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='OLT.IPAddress' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='OLT.MACAddress' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='OLT.Slot' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='OLT.Status.LinkStatus' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='OLT.Status.CTC' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='OLT.Status.NVS' />)} /></td>
            <td><input type="text" className="input-footer" placeholder={ReactDOMServer.renderToString(<Translate transVar='OLT.Status.Version' />)} /></td>
            <td></td>
          </tr>
        </tfoot>
      </>
    );
  }

  tBody = () => {
    let arrTd = []
    this.state.rows.forEach((e, i) => {
      arrTd.push(
        <tr key={i}>
          <td>{e.id}</td>
          <td>{e.ucCfgOLTName}</td>
          <td>{e.ucCfgOLTIpAddress}</td>
          <td>{e.ucCfgOLTMac}</td>
          <td>{e.ucCfgOLTSlotIndex}</td>
          <td>{e.ucSlotStatus}</td>
          <td>{e.ucCfgOLTCtcDisable}</td>
          <td>{e.uCCfgOLTNvsEnabled}</td>
          <td>{e.ucCfgOLTApp1Version}</td>
          <td><Link to={{ pathname: `/olt/status/config/` + e.id }}><i className="fas fa-cog"></i></Link></td>
        </tr>
      )
    });
    return (
      <>
        <tbody>{arrTd}</tbody>
      </>
    )
  }

  render() {
    return (
      <>
        <ModalLoading show={this.state.mLoading} />
        {!this.state.mLoading &&
          <table width="100%" ref={(tbl) => (this.tbl = tbl)} className='table table-striped'>
            <this.tHeader />
            <this.tBody />
            <this.tFooter />
          </table>
        }
      </>
    )
  }
}
